import { render, staticRenderFns } from "./six.vue?vue&type=template&id=d4670054"
import script from "./six.vue?vue&type=script&lang=js"
export * from "./six.vue?vue&type=script&lang=js"
import style0 from "./six.vue?vue&type=style&index=0&id=d4670054&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports